import toast from "../utils/ToasterService"

const DE = {
    Global: {
        button_back: 'Zurück',
        button_cancel: 'Abbrechen',
        button_ok: 'OK',
        button_open: 'Öffnen',
        button_reset: 'Zurücksetzen',
        button_save_changes: 'Änderungen speichern',
        heading_caution: 'Achtung',
        heading_caution_caps_lock: 'ACHTUNG',
        title_email: 'E-Mail',
        title_legal_notice: 'Impressum',
        title_password: 'Passwort',
        title_privacy_statement: 'Datenschutzerklärung',
        text_none: 'Keine',
        toast_error: 'Hoppla, da ist etwas schiefgelaufen, bitte erneut versuchen.',
        toast_server_disconnect:'Server nicht erreichbar, bitte versuchen Sie es später.'
      },
      PageTitles: {
        areas:'Bereiche',
        devices: 'Geräte',
        setup: 'Setup',
        user: 'Benutzer',
        settings: 'Einstellungen',
        about: 'Über '
      },
      Authentication: {
        button_signin: 'Login',
        button_signup: 'Registrieren',
        button_password_forgot: 'Passwort vergessen',
        toast_error: 'E-Mail oder Passwort nicht korrekt!'
      },
      ChooseLanguage: {
        button_choose_language: 'Sprache auswählen'
      },
      DeviceCard: {
        label_id: 'Geräte-ID',
        label_state: 'Status',
        content_update: 'Geräteupdate notwendig.',
        content_state_online: 'online',
        content_state_offline: 'Nicht verbunden.',
      },
      DeviceInformation: {
        toast_device_activation_success_01: 'Das Gerät ',
        toast_device_activation_success_02: ' wurde aktiviert.',
        toast_device_deletion_success_01: 'Das Gerät ',
        toast_device_deletion_success_02: ' wurde entfernt.',
        sidebar_header_dialog_devices_title: 'Geräteinformationen',
        sidebar_header_dialog_activation_hint: 'HINWEIS: ',
        sidebar_header_dialog_activation_text_01: 'Durch Betätigen des Speichern Buttons wird',
        sidebar_header_dialog_activation_text_02: 'das derzeitig aktivierte Gerät deaktiviert',
        sidebar_header_dialog_activation_text_03: 'und ist bis zur erneuten Aktvierung nicht steuerbar.',
        sidebar_header_dialog_device_deletion_caution: 'ACHTUNG: ',
        sidebar_header_dialog_device_deletion_text_01: 'Durch Betätigen des Speichern Buttons wird',
        sidebar_header_dialog_device_deletion_text_02: 'das Gerät vom Benutzerkonto entfernt.',
        sidebar_header_dialog_device_deletion_text_03: 'Benutzer die mit dem Gerät verbunden sind können es jedoch weiterhin nutzen.',
        sidebar_header_dialog_device_deletion_text_04: 'Sie können es erneut hinzufügen, wenn es sich in Ihrem Netzwerk befindet.',
        sidebar_header_dialog_user_deletion_title: 'Konto löschen',
        sidebar_header_dialog_user_deletion_caution: 'ACHTUNG: ',
        sidebar_header_dialog_user_deletion_text_01: 'Durch Betätigen des LÖSCHEN Buttons wird der',
        sidebar_header_dialog_user_deletion_text_02: 'Benutzer von diesem Gerät entfernt. Dieser Vorgang',
        sidebar_header_dialog_user_deletion_text_03: 'kann nicht rückgänig gemacht werden.',
        sidebar_header_dialog_user_deletion_text_04_s: 'Dieser Vorgang kann nicht rückgängig gemacht werden!',
        sidebar_users_section_subheading: 'Benutzer',
        sidebar_users_section_caption: 'E-Mail Adressen, die mit diesem Gerät verbunden sind.',
        sidebar_sensors_section_subheading: 'Sensorwerte',
        sidebar_sensors_section_caption: 'Ausgabe der Sensorwerte des angeschlossenen Geräts. ',
        sidebar_sensors_section_relative_humidity: 'rF',
        sidebar_sensors_section_no_sensor: 'kein Sensor',
        sidebar_messages_section_subheading: 'Meldungen',
        sidebar_messages_section_caption: 'Fehlermeldungen zu Ihrem angeschlossenen Gerät.',
        sidebar_messages_section_text_actual: 'Aktuell',
        sidebar_messages_section_text_last: 'Letzte Meldung',
        sidebar_uptime_section_subheading: 'Betriebszeit',
        sidebar_uptime_section_caption: 'Zeit seit Anschluss des Geräts oder seit letztem Zurücksetzen.',
        sidebar_uptime_section_text_years: 'Jahr(e)',
        sidebar_uptime_section_text_days: 'Tag(e)',
        sidebar_uptime_section_text_hours: 'Stunde(n)',
        sidebar_uptime_section_text_minutes: 'Minute(n)',
        sidebar_gateway_specs_section_subheading: 'Informationen',
        sidebar_gateway_specs_section_caption: 'Hard- und Software Details des angeschlossenen Gateways.',
        sidebar_gateway_specs_section_article_code: 'Artikel Code',
        sidebar_gateway_specs_section_device_id: 'Geräte-ID',
        sidebar_gateway_specs_section_firmware: 'Firmware',
        sidebar_device_specs_section_subheading: 'Informationen',
        sidebar_device_specs_section_caption: 'Hard- und Software Details der Komponenten.',
        sidebar_device_specs_section_control: 'Zentrale Steuerung',
        sidebar_device_specs_section_bde_not_connected: 'nicht verbunden',
        sidebar_control_header: 'Steuerung',
        sidebar_gateway_title: 'Gateway',
        sidebar_gateway_subheading: 'Status',
        sidebar_gateway_title: 'Welches Gateway wird aktiv gesteuert.',
        button_gateway_activate: 'AKTIVIEREN',
        button_gateway_activated: 'AKTIVIERT',
        sidebar_gateway_subheading_delete: 'Gateway entfernen',
        sidebar_gateway_caption_delete: 'Die Verknüpfung zwischen Gerät und Benutzerkonto wird aufgehoben.',
        button_gateway_delete_delete: 'LÖSCHEN',
        error_message_000: 'Keine Meldung',
        error_message_001: 'Filter abgelaufen',
        error_message_002: 'Keine Freigabe',
        error_message_128: 'Kommunikationsfehler',
        error_message_129: 'Eingangswert außerhalb des gültigen Bereichs (',
        error_message_130: 'Kein CO2 Sensor für Messwert angeschlossen',
        error_message_131: 'Das Gerät besitzt die falsche Busversion',
      },
      Devices: {
        toast_device_creation_success_01: 'Das Gerät ',
        toast_device_creation_success_02: ' wurde hinzugefügt.',
        toast_device_creation_error: 'Gerät konnte nicht hinzugefügt werden.',
        sidebar_header_create: 'Gerät hinzufügen',
        sidebar_item_header_create: 'Bitte die Geräte ID und eine beliebige Bezeichnung eingeben.',
        sidebar_input_label_deviceid_create: 'Geräte ID',
        sidebar_input_label_devicename_create: 'Geräte Bezeichnung',
        button_connect: 'VERBINDUNG HERSTELLEN',
        card_title_active: 'Aktiv',
        card_replacement_no_active_devices: 'Keine aktiven Geräte gefunden.',
        card_title_other: 'Weitere Geräte',
        card_replacement_no_inactive_devices: 'Keine inaktiven Geräte gefunden.'
      },
      Information: {
        headline: 'Impressum',
        company_name: 'SEVentilation GmbH',
        legal_info: 'Verantwortlich für den Inhalt dieser Webseite im Sinne des Presserechts, des § 6 MDStV und des § 6 TDG:',
        ceo_technic_heading: 'Geschäftsführer Technik',
        ceo_technic: 'Dipl.-Wirt.-Ing. (FH) Nico Schellenberg',
        ceo_sales_heading: 'Geschäftsführer Vertrieb',
        ceo_sales: 'Dipl.-Wirt.-Ing. (FH) Alexander Buchspieß',
        ceos_address_heading: 'Sitz der Gesellschaft',
        ceos_address: 'Ernst Thälmann Str. 12-14<br/>07768 Kahla',
        contact_info_heading: 'Kontakt',
        contact_info: 'Tel.: +49 (0)36424 767472<br/>E-Mail: info@seventilation.de',
        commercial_register_heading: 'Handelsregister',
        commercial_register: 'HRB 510003<br/>Amtsgericht Jena',
        vat_heading: 'USt-IdNr.',
        vat: 'DE293854001',
        privacy_heading: 'Datenschutz'
      },
      NoDevicesScreen: {
        heading: 'HINWEIS',
        subheading: 'Aktuell ist kein Gerät aktiviert. Im Menü "Geräte" kann ein vorhandes Gerät aktiviert werden.',
        button_open_devices: 'GERÄTE ÖFFNEN'
      },
      Onboarding: {
        title_device_registration: 'Geräteanmeldung',
        helper_text_device_registration: 'Geben Sie hier ihre Device ID ein. Stellen Sie dabei sicher, dass Ihr Gerät eine aktive Internetverbindung hat und Sie sich im gleichen Netzwerk befinden.'
      },
      PasswordNew: {
        button_back_to_signin: 'Zurück zum Login',
        button_reset_password: 'Passwort zurücksetzen',
        button_submit_new_password: 'Passwort setzen',
        error_text_repeat_password: 'Die Passwörter stimmen nicht überein.',
        text_field_assign_new_password: 'Neues Passwort festlegen',
        text_field_confirm_new_password: 'Neues Passwort bestätigen',
        toast_success: 'Passwort erfolgreich geändert. Sie können sich nun einloggen.',
        toast_error: 'Eingabefehler, bitte neues Passwort überprüfen und korrigieren!',
        toast_error_wrong_password: 'Das aktuelle Passwort ist ungültig.',
        toast_error_token_invalid: 'Der Link ist ungültig oder abgelaufen, bitte erneut versuchen.',
        success_text: 'Passwort wurde erfolgreich geändert.'
      },
      PasswordReset: {
        title: 'Kontowiederherstellung',
        textfield_email_helpertext: 'Ihre registrierte E-Mail Adresse',
        textfield_email_helpertext_error: 'E-Mail Adresse nicht vorhanden oder falsch',
        button_send_password: 'E-Mail zusenden',
        success_text: 'Wir haben Ihnen einen Link zum Zurücksetzen ihres Passworts gesendet.',
        toast_success: 'Bestätigungsmail erfolgreich gesendet.',
        toast_error: 'Eingabefehler, bitte E-Mail Adresse überprüfen und korrigieren!',
        toast_error_no_user: 'Es wurde kein Benutzer mit dieser E-Mail Adresse gefunden.',
        button_to_signin: 'Zum Login',
      },
      Registration: {
        title: 'Konto erstellen',
        toast_success: 'Sie haben sich erfolgreich registriert. Bitte prüfen Sie Ihren Posteingang für eine Bestätigungsmail.',
        toast_error: 'Eingabefehler, bitte Eingaben überprüfen und korrigieren!',
        helpertext_error_password: 'Die Passwörter stimmen nicht überein.',
        textfield_helpertext_password: 'Das Passwort muss mindestens 12 Zeichen haben.',
        text_success:'Sie haben sich erfolgreich registriert. Bitte prüfen Sie Ihren Posteingang für eine Bestätigungsmail.',
        helpertext_error_email: 'E-Mail Adresse ist nicht korrekt',
        label_choose_initial_password: 'Passwort festlegen',
        label_confirm_initial_password: 'Passwort bestätigen',
        button_signup: 'Registrieren',
        button_signin: 'Zum Login',
      },
      Settings: {
        sidebar_title_filter: 'Filter',
        sidebar_title_thresholds: 'Schwellwerte',
        sidebar_title_sleep: 'Schlummerzeit',
        sidebar_title_devicetime: 'Gerätezeit',
        sidebar_title_summerventilation: 'Sommerlüftung',

        text_date_time: ' Uhr',
        heading: 'Einstellungen',
        card_label_filter: 'Filter',
        card_text_filter_change_01: 'Wechsel',
        card_text_filter_change_02: 'in ',
        card_text_filter_change_03: ' Tagen',
        card_text_filter_runtime_01: 'Laufzeit',
        card_text_filter_runtime_02: ' Tage',
        card_label_thresholds: 'Schwellwerte',
        card_text_thresholds_01: 'CO2',
        card_text_thresholds_02: 'Feuchte',
        card_label_sleep: 'Schlummerzeit',
        card_text_sleep_01: 'Dauer',
        card_text_sleep_02: ' Min',
        card_label_devicetime: 'Gerätezeit',
        card_text_devicetime_01: 'Datum',
        card_text_devicetime_02: 'Zeit',
        card_label_summerventilation: 'Sommerlüftung',
        card_text_summerventilation_state: 'Status',
        card_text_summerventilation_active: 'aktiviert',
        card_text_summerventilation_not_active: 'nicht aktiviert',
        card_helperlabel_summerventilation: 'Hinweis',
        card_helpertext_summerventilation: 'keine Wärmerück-gewinnung',

        sidebar_item_title_filter: 'Filterwechsel',
        sidebar_item_subtitle_filter_01: 'In ',
        sidebar_item_subtitle_filter_02: ' Tagen. Nach dem Filterwechsel setzten Sie bitte die Filterlaufzeit zurück.',
        sidebar_item_input_title_filter: 'Filterlaufzeit',
        sidebar_item_input_subtitle_filter: 'Dies ist die Zeit, nach der der Filter erneuert werden muss.',
        sidebar_item_input_helpertext_filter_01: 'Wert zwischen ',
        sidebar_item_input_helpertext_filter_02: ' und ',
        sidebar_item_input_helpertext_filter_03: ' Tagen in Schritten von ',
        sidebar_item_input_helpertext_filter_04: '  Tagen.',
        sidebar_item_input_label_filter: 'Filterlaufzeit in Tagen',

        sidebar_item_title_thresholds_co2: 'CO2',
        sidebar_item_helpertext_thresholds_co2_01: 'Wert zwischen ',
        sidebar_item_helpertext_thresholds_co2_02: ' und ',
        sidebar_item_helpertext_thresholds_co2_03: ' ppm in Schritten von ',
        sidebar_item_helpertext_thresholds_co2_04: ' ppm.',
        sidebar_item_label_thresholds_co2: 'Schwellwert',
        sidebar_item_infotext_thresholds_co2_01: 'Der aktuelle CO2-Wert beträgt ',
        sidebar_item_infotext_thresholds_co2_02: ' ppm.',

        sidebar_item_title_thresholds_humidity: 'Feuchte',
        sidebar_item_helpertext_thresholds_humidity_01: 'Wert zwischen ',
        sidebar_item_helpertext_thresholds_humidity_02: ' und ',
        sidebar_item_helpertext_thresholds_humidity_03: ' %.',
        sidebar_item_label_thresholds_humidity: 'Schwellwert',
        sidebar_item_infotext_thresholds_humidity_01: 'Die aktuelle Feuchte beträgt ',
        sidebar_item_infotext_thresholds_humidity_02: ' %.',

        sidebar_item_title_sleep: 'Schlummerzeit',
        sidebar_item_helpertext_sleep_01: 'Wert zwischen ',
        sidebar_item_helpertext_sleep_02: ' und ',
        sidebar_item_helpertext_sleep_03: ' Minuten.',
        sidebar_item_label_sleep: 'Zeit einstellen',

        sidebar_item_title_summerventilation_active: 'Sommerlüftung ist aktiviert',
        sidebar_item_title_summerventilation_inactive: 'Sommerlüftung ist deaktiviert',
        sidebar_item_helpertext_summerventilation:'Wenn die Sommerlüftung aktiv ist, erfolgt keine Wärmerückgewinnung.',

        sidebar_item_devicetime_switch_active: 'Automatische Synchronisierung ist aktiviert',
        sidebar_item_devicetime_switch_inactive: 'Automatische Synchronisierung ist deaktiviert',
        sidebar_item_devicetime_switch_disabled: 'Automatische Synchronisierung ist nicht verfügbar',
        sidebar_item_devicetime_infotext: 'Wenn die Automatische Synchronisierung aktiv ist, können Uhrzeit und Datum nicht manuell eingestellt werden.',
        sidebar_item_devicetime_label: 'Aktuelle Gerätezeit',
        sidebar_item_devicetime_button_submit: 'Übernehmen',
        sidebar_item_devicetime_firmwareupdate_infotext: 'Firmwareupdate ausstehend, die Funktion ist in Kürze verfügbar.',

      },
      Setup: {
        text_factoryreset_01: 'Durch Betätigen des SPEICHERN Buttons wird der ursprüngliche Lieferzustand wiederhergestellt. Die Betriebsstunden des Systems werden auch zurückgesetzt.',
        text_factoryreset_02: 'Dieser Vorgang kann nicht rückgänig gemacht werden.',
        name_area: 'Bereich',
        menuitem_default: 'Bitte wählen Sie',
        menuitem_boostmode_both: 'Zu- und Abluft',
        menuitem_boostmode_supply: 'Zuluft',
        menuitem_boostmode_exhaust: 'Abluft',
        helpertext_boostmode: 'Stoßlüftungsbetrieb',
        name_system: 'System',
        menuitem_system_none: 'Keins',
        menuitem_system_configurable_device: 'Konfigurierbares Gerät',
        helpertext_systems: 'Typ des Lüftungssystems',
        menuitem_area1: 'Bereich 1',
        menuitem_area2: 'Bereich 2',
        menuitem_area3: 'Bereich 3',
        menuitem_area4: 'Bereich 4',
        menuitem_area5: 'Bereich 5',
        menuitem_area6: 'Bereich 6',
        helpertext_areas_installed: 'Installiert im Bereich',
        sidebar_title_ai: 'Einstellung',
        menuitem_ai_0_10V: '0-10V',
        menuitem_ai_4_20mA: '4-20mA',
        helpertext_ai_kind: 'Beschaltung des Eingangs',
        menuitem_ai_none: 'Keine',
        menuitem_ai_fanlevel: 'Lüfterstufe',
        menuitem_ai_humidity: 'Feuchte',
        menuitem_ai_co2: 'CO2',
        menuitem_ai_ti: 'Innentemperatur',
        menuitem_ai_ta: 'Aussentemperatur',
        helpertext_ai_function: 'Funktion des Eingangs',
        formtitle_ai_set_characteristic: 'Kennlinie einstellen',
        sidebartitle_ai_choose_areas: 'Bereichsauswahl',
        sidebar_title_di: 'Einstellung',
        menuitem_di_none: 'Keine',
        menuitem_di_set_fanlevel: 'Setze Lüfterstufe ',
        menuitem_di_set_boost: 'Setze Stoßlüftung',
        menuitem_di_set_sleep: 'Setze Schlummer',
        menuitem_di_set_time_automatic: 'Setze Zeitautomatik',
        menuitem_di_set_co2: 'Setze CO2',
        menuitem_di_set_humidity: 'Setze Feuchte',
        menuitem_di_set_filter: 'Setze Filter zurück',
        menuitem_di_hold_fanlevel: 'Halte Lüfterstufe ',
        menuitem_di_hold_boost: 'Halte Stoßlüftung',
        menuitem_di_hold_time_automatic: 'Halte Zeitautomatik',
        menuitem_di_hold_co2: 'Halte CO2',
        menuitem_di_hold_humidity: 'Halte Feuchte',
        helpertext_di_function: 'Funktion des Eingangs',
        sidebartitle_di_choose_areas: 'Bereichsauswahl',
        sidebar_title_do: 'Einstellung',
        menuitem_do_none: 'Keine',
        menuitem_do_fan_active_01: 'Lüfterstufe ',
        menuitem_do_fan_active_02: ' aktiv',
        menuitem_do_boost: 'Stoßlüftung aktiv',
        menuitem_do_sleep: 'Schlummer aktiv',
        menuitem_do_all_zero: 'Alle Bereiche Lüfterstufe 0',
        menuitem_do_time_automatic: 'Zeitautomatik aktiv',
        menuitem_do_co2: 'CO2 aktiv',
        menuitem_do_humidity: 'Feuchte aktiv',
        menuitem_do_filter: 'Filter abgelaufen',
        menuitem_do_message: 'Allgemeine Meldung',
        menuitem_do_error: 'Allgemeiner Fehler',
        helpertext_do_function: 'Funktion des Ausgangs',
        sidebartitle_do_choose_areas: 'Bereichsauswahl',
        card_label_systems: 'Lüftungssysteme',
        card_text_systems_01: 'Anzahl',
        card_text_systems_02: 'Systeme aktiv',
        card_label_boost: 'Bereiche',
        card_text_boost_01: 'Stoßlüftung',
        card_text_boost_02: 'der Bereiche',
        card_text_boost_03: 'einstellen',
        card_label_di: 'Eingang DI',
        card_text_di_01: 'Funktion',
        card_text_di_02: 'Bereiche',
        card_label_ai: 'Eingang AI',
        card_text_ai_01: 'Funktion',
        card_text_ai_02: 'Bereiche',
        card_label_do: 'Ausgang DO',
        card_text_do_01: 'Funktion',
        card_text_do_02: 'Bereiche',
        card_label_factory_reset: 'Werkseinstellungen',
        card_text_factory_reset_01: 'System auf',
        card_text_factory_reset_02: 'Werksdaten',
        card_text_factory_reset_03: 'zurücksetzen',
        sidebartitle_curve: 'Kennlinie einstellen',
        sidebar_text_factory_reset: 'Zurücksetzen'
      },
      SetupAuthorization: {
        paragraph_caution: 'Dieser Bereich enthält Einstellungen für die Inbetriebnahme oder den Service. Änderungen sollten nur mit Bedacht vorgenommen werden.',
      },
      UpdateScreen: {
        headline: 'UPDATE NOTWENDIG',
        subheading_01: 'Das aktivierte Gerät muss aktualisiert werden.',
        subheading_02: 'Bitte lassen Sie das Gerät mindestens 24h aktiv am Netz angeschlossen.',
        subheading_03: 'Unter "Geräte" kann so lange ein anderes Gerät aktiviert werden.',
        button_open_devices: 'GERÄTE ANZEIGEN'
      },
      User: {
        heading_account_administration_delete: 'Konto löschen',
        sub_heading_account_administration_delete: 'Löschen Sie das Konto und alle Daten' ,
        sidebartext_caution_delete_01: 'Durch Betätigen des LÖSCHEN Buttons wird der Zugang und alle dazugehörigen Daten gelöscht.',
        sidebartext_caution_delete_02: 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
        button_delete_account: 'Konto löschen',
        siebartext_change_password: 'Sie möchten Ihr Passwort ändern? Bitte geben Sie ihr aktuelles Passwort zuerst ein.',
        title_api_access: 'Dokumentation',
        subtitle_api_access: 'Unter folgendem Link werden Sie zur Beschreibung der API weitergeleitet.',
        title_token: 'Token',
        subtitle_token: 'Mit einem persönlichen Token erhalten Sie Zugriff auf die SEC-Smart API.',
        textfield_label_token: 'Zugangsdaten kopieren',
        textfield_value_token:'Kein Token erstellt',
        button_create: 'Erstellen',
        button_revert:'Zurücknehmen',
        title_token_information: 'Information',
        text_token_information: 'Stellen Sie sicher, dass Sie das Token speichern. Sie werden nicht mehr darauf zugreifen können.',
        title_personalinformation_account: 'Benutzerkonto',
        subtitle_personalinformation_account: 'Die mit dem Konto verbundene E-Mail Adresse',
        title_personalinformation_password: 'Passwort',
        subtitle_personalinformation_password: 'Setzen Sie ein neues Passwort für Ihren Zugang',
        sidebartitle_passwordchange_no_action: 'Persönliche Daten',
        sidebartitle_passwordchange_action: 'Passwort ändern',
        sidebartitle_account_no_action: 'Kontoverwaltung',
        sidebartitle_account_action: 'Konto löschen',
        sidebartitle_api_no_action: 'SEC-Smart API',
        sidebartitle_api_action: 'Token erstellt',
        toast_password_change_success: 'Passwort erfolgreich geändert.',
        toast_account_deletion_success: 'Account erfolgreich gelöscht.',
        card_label_personal_data: 'Persönliche Daten',
        card_text_personal_data_01: 'Kontakt-',
        card_text_personal_data_02: 'informationen',
        card_text_personal_data_03: 'einsehen oder',
        card_text_personal_data_04: 'das Passwort',
        card_text_personal_data_05: 'ändern',
        card_label_account_administration: 'Kontoverwaltung',
        card_text_account_administration_01: 'Hier können',
        card_text_account_administration_02: 'Sie Ihre Daten',
        card_text_account_administration_03: 'herunterladen',
        card_text_account_administration_04: 'oder löschen',
        card_label_api: 'SEC-Smart API',
        card_text_api_01: 'Beschreibung',
        card_text_api_02: 'einsehen &',
        card_text_api_03: 'Zugriffstoken',
        card_text_api_04: 'verwalten',
        button_change: 'Ändern',
        button_change_password: 'Passwort ändern',
        label_actual_password: 'Aktuelles Passwort',
        label_choose_new_password: 'Neues Passwort festlegen',
        label_confirm_new_password: 'Neues Passwort bestätigen',
        label_confirm_deletion: 'Löschen bestätigen',
        helpertext_account_deletion: "Zum Bestätigen 'DELETE' eingeben."
      },
      Scopes: {
        cardtext_label_manual: 'Manuell',
        cardtext_content_manual: 'Stufe',
        cardtext_label_boost: 'Stoßlüften',
        cardtext_content_boost: 'Maximale Lüftungsleistung',
        cardtext_label_sleep: 'Schlummer',
        cardtext_content_sleep: '',
        cardtext_label_humi: 'Feuchte',
        cardtext_content_humi: 'Wert',
        cardtext_label_time: 'Zeitprogramm',
        cardtext_content_time: '',
        cardtext_label_co2: 'CO2',
        cardtext_content_co2: 'Wert',
        title_mode_manual: 'Manuell',
        title_mode_boost: 'Stoßlüften',
        title_mode_sleep: 'Schlummer',
        title_mode_humi: 'Feuchte',
        title_mode_time: 'Zeitprogramm',
        title_mode_co2: 'CO2',
        title_sidebar_customzie_area:'Bereich anpassen',
        title_sidebar_customzie_time:'Schaltzeit konfigurieren',
        title_dropwon_choose: 'Bitte wählen Sie',
        helpertext_choose_area_name: 'Name für Bereich wählen',
        title_mode: 'Modus',
        subtitle_mode: 'Betriebsmodus für den Bereich einstellen',
        label_modeitem_manual:'Manuell',
        label_modeitem_boost:'Stoßlüften',
        label_modeitem_sleep:'Schlummer',
        label_modeitem_humi:'Feuchte',
        label_modeitem_time:'Zeitprogramm',
        label_modeitem_co2:'CO2',
        label_fanlevel: 'Lüfterstufe',
        information_mode_boost_01: 'Es wird mit maximaler Lüftungsleistung gelüftet.',
        information_mode_boost_02: 'Bitte sorgen Sie für genügend Zuluft.',
        information_mode_sleep_01: 'Die Lüftung wird für ',
        information_mode_sleep_02: ' Minuten ausgeschaltet und',
        information_mode_sleep_03: ' läuft dann mit Lüfterstufe 1 weiter',
        information_mode_humi_01: 'Es wird nach der relativen Luftfeuchte im Raum gelüftet.',
        information_mode_humi_02: 'Die aktuelle Feuchte beträgt',
        information_mode_time_01: 'Es wird nach eingestellten Zeitprogramm gelüftet.',
        information_mode_co2_01: 'Die Lüftung erfolgt anhand der CO2-konzentration in der Luft.',
        information_mode_co2_02: 'Der aktuelle CO2-Wert beträgt ',
        label_timepicker: 'Zeitpunkt der nächsten Schaltzeit einstellen.'

      },
      Misc: {
          label_switchtime: 'Schaltzeit ',
          sidebar_item_helpertext_ai_curve_01: 'Wert zwischen ',
          sidebar_item_helpertext_ai_curve_02: ' und ',
          navigation_item_choose_language: 'Sprache',
          navigation_item_logout: 'Abmelden',
      }
}

export default DE
